import {
    FETCH_LEARNINGPATH,
    EMPTY_LEARNINGPATH,
    START_LEARNINGPATH,
    STARTED_LEARNINGPATH,
    RESET_LEARNINGPATH,
} from '@/learningpath/actions/learningpath';

const app = (state = {}, action) => {
    const {type, payload} = action;

    switch (type) {
        case `${FETCH_LEARNINGPATH}_PENDING`: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case `${FETCH_LEARNINGPATH}_FULFILLED`: {
            const learningPathStarted = payload != null;

            return {
                ...state,
                ...payload,
                learningPathStarted: learningPathStarted,
                started: false,
                isLoading: false,
            };
        }
        case `${FETCH_LEARNINGPATH}_REJECTED`: {
            return {
                learningPathStarted: false,
                started: false,
                isLoading: false,
            };
        }

        case EMPTY_LEARNINGPATH: {
            return {
                learningPathStarted: false,
                started: false,
                isLoading: false,
            };
        }

        case `${START_LEARNINGPATH}_PENDING`: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case `${START_LEARNINGPATH}_FULFILLED`: {
            const learningPathStarted = payload != null;

            return {
                ...state,
                ...payload,
                learningPathStarted: learningPathStarted,
                started: true,
                isLoading: false,
            };
        }
        case `${START_LEARNINGPATH}_REJECTED`: {
            return {
                learningPathStarted: false,
                started: false,
                isLoading: false,
            };
        }

        case STARTED_LEARNINGPATH: {
            return {
                ...state,
                started: false,
            };
        }

        case `${RESET_LEARNINGPATH}_PENDING`: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case `${RESET_LEARNINGPATH}_FULFILLED`: {
            const learningPathStarted = payload != null;

            return {
                ...state,
                ...payload,
                learningPathStarted: learningPathStarted,
                started: true,
                isLoading: false,
            };
        }
        case `${RESET_LEARNINGPATH}_REJECTED`: {
            return {
                learningPathStarted: false,
                started: false,
                isLoading: false,
            };
        }

        default:
            return state;
    }
};

export default app;
